module.exports = __webpack_public_path__ + "static/lhs-video-banner-50c5e44f45e9838eef8105c34722de37.jpg";